import axios from 'axios';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';

export const GET_EVENTS = '[CALENDAR APP] GET EVENTS';
export const SET_COUNTRY = '[CALENDAR APP] SET COUNTRY';
export const OPEN_NEW_EVENT_DIALOG = '[CALENDAR APP] OPEN NEW EVENT DIALOG';
export const CLOSE_NEW_EVENT_DIALOG = '[CALENDAR APP] CLOSE NEW EVENT DIALOG';
export const OPEN_EDIT_EVENT_DIALOG = '[CALENDAR APP] OPEN EDIT EVENT DIALOG';
export const CLOSE_EDIT_EVENT_DIALOG = '[CALENDAR APP] CLOSE EDIT EVENT DIALOG';
export const ADD_EVENT = '[CALENDAR APP] ADD EVENT';
export const UPDATE_EVENT = '[CALENDAR APP] UPDATE EVENT';
export const REMOVE_EVENT = '[CALENDAR APP] REMOVE EVENT';

const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.holidays}`;

export function getEvents() {
	const request = axios.get(url); //'/api/calendar-app/events'
	return dispatch =>
		request.then(response =>
			dispatch({
				type: GET_EVENTS,
				payload: response.data._embedded.holidays
			})
		);
}

export function openNewEventDialog(data) {
	return {
		type: OPEN_NEW_EVENT_DIALOG,
		data
	};
}

export function setCountry(payload) {
	return {
		type: SET_COUNTRY,
		payload
	};
}

export function closeNewEventDialog() {
	return {
		type: CLOSE_NEW_EVENT_DIALOG
	};
}

export function openEditEventDialog(data) {
	return {
		type: OPEN_EDIT_EVENT_DIALOG,
		data
	};
}

export function closeEditEventDialog() {
	return {
		type: CLOSE_EDIT_EVENT_DIALOG
	};
}

export function addEvent(newEvent) {
	return (dispatch, getState) => {
		const request = axios.post(url, newEvent);
		
		return request.then(response =>
			Promise.all([
				dispatch({
					type: ADD_EVENT
				})
			]).then(() => dispatch(getEvents()))
		);
	};
}

export function updateEvent(event) {
	return (dispatch, getState) => {
		const request = axios.put(url + '/' + event.id, event);

		return request.then(response =>
			Promise.all([
				dispatch({
					type: UPDATE_EVENT
				})
			]).then(() => dispatch(getEvents()))
		);
	};
}

export function removeEvent(eventId) {
	return (dispatch, getState) => {
		const request = axios.post(url, eventId);
		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_EVENT
				})
			]).then(() => dispatch(getEvents()))
		);
	};
}
